export const APPOINTMENTS_PROVIDER = 'APPOINTMENTS_PROVIDER';
export const APPOINTMENTS_CUSTOMER = 'APPOINTMENTS_CUSTOMER';
export const APPOINTMENTS_SUBJECTS = 'APPOINTMENTS_SUBJECTS';
export const APPOINTMENTS_SCHEDULE = 'APPOINTMENTS_SCHEDULE';
export const APPOINTMENTS_STATUS = 'APPOINTMENTS_STATUS';
export const APPOINTMENTS_SUMMARY = 'APPOINTMENTS_SUMMARY';
export const APPOINTMENTS_PRESCRIPTIONS = 'APPOINTMENTS_PRESCRIPTIONS';
export const APPOINTMENTS_CONVERSATION = 'APPOINTMENTS_CONVERSATION';
export const APPOINTMENTS_FILES = 'APPOINTMENTS_FILES';

export const APPOINTMENTS_PROVIDER_AVAILABILITY_STATUS = 'APPOINTMENTS_PROVIDER_AVAILABILITY_STATUS';
export const APPOINTMENTS_CUSTOMER_AVAILABILITY_STATUS = 'APPOINTMENTS_CUSTOMER_AVAILABILITY_STATUS';

export const APPOINTMENTS = 'APPOINTMENTS';
export const APPOINTMENTS_STATUS_CANCELED = 'APPOINTMENTS_STATUS_CANCELED';

export const APPOINTMENTS_CASE_SUMMARY = 'APPOINTMENTS_CASE_SUMMARY';
